import numbro from 'numbro';
import React from 'react';
import { AppState } from 'src/AppState';
import styled from 'styled-components';

import { IconPayout } from '../easyclaim.app.assets/icons/Payout';
import { CenteredCircle, DetailContainer, Input, Main } from '../easyclaim.app.components/index';
import { FormattedMessage } from '../easyclaim.app.internationalization/index';
import theme from '../easyclaim.app.theme/theme';

import { ScreenComponent } from './ScreenComponent';

interface VehicleInformationState {}
export class Payout extends ScreenComponent<AppState, VehicleInformationState> {
	constructor(props: AppState) {
		super(props);

		this.state = {};
	}

	public render() {
		const calculation = this.props.easyClaimCalculationResult;

		return (
			<div className="main-container">
				<Main>
					<h2 className="payout-title">
						<FormattedMessage id="payout.headline.first" />
					</h2>
					<DetailContainer>
						<CenteredCircle
							size="6rem"
							borderColor={theme.colors.icon.primary}
							borderStyle="solid"
							borderWidth="3px"
						>
							<StyledPayoutIcon />
						</CenteredCircle>
						{/* <Paragraph>
                            <>
                            TODOKG: missing
                                <FormattedMessage
                                    id="payout.paragraph"
                                    values={{
                                        payoutAmount: (
                                            <b>
                                                {calculation &&
                                                    calculation.payoutAmount &&
                                                    numbro(calculation.payoutAmount).formatCurrency()}
                                            </b>
                                        ),
                                    }}
                                />
                            </>
                        </Paragraph> */}
						<h3 className="payout-bankaccount-owner-title">
							<FormattedMessage id="payout.headline.second" />
						</h3>
						<Input
							type="text"
							autoCorrect="off"
							spellCheck={false}
							value={
								this.props.easyClaimCase && this.props.easyClaimCase.bankAccountOwnerName
									? this.props.easyClaimCase.bankAccountOwnerName
									: ''
							}
							isValid={this.props.appService.isBankAccountOwnerValid()}
							onChange={(e) => {
								const easyClaimCase = this.props.appService.app.state.easyClaimCase!;

								easyClaimCase.bankAccountOwnerName = e.target.value;
								this.props.appService.app.setState({ easyClaimCase });
							}}
							isRequired={true}
						/>
						<h3 className="payout-bankaccount-number-title">
							<FormattedMessage id="payout.headline.third" />
						</h3>
						<Input
							type="text"
							autoCorrect="off"
							spellCheck={false}
							isValid={this.props.appService.isBankAccountNumberValid()}
							showInvalid={true}
							value={
								this.props.easyClaimCase && this.props.easyClaimCase.bankAccountNumber
									? this.props.easyClaimCase.bankAccountNumber
									: ''
							}
							onChange={(e) => this.props.appService.updateCaseBankAccount(e.target.value)}
							style={{ fontSize: '0.85rem' }}
							maxLength={32}
							isRequired={true}
						/>
					</DetailContainer>
				</Main>
			</div>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;

const StyledPayoutIcon = styled(IconPayout)`
	height: 4rem;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.success};
`;
